import { render } from "./CategoriesList.vue?vue&type=template&id=72ad4e32&ts=true"
import script from "./CategoriesList.vue?vue&type=script&lang=ts"
export * from "./CategoriesList.vue?vue&type=script&lang=ts"

import "./CategoriesList.vue?vue&type=style&index=0&id=72ad4e32&lang=css"

import exportComponent from "D:\\YellowBeardProject\\yellowrock\\yellowrockNew\\yellowrocknewshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__